module.exports = __webpack_public_path__ + "media/images/common/menu_tops-628965cd766a50d97b647759bfac8f79.gif";